import React from 'react';
import './banner.scss';

const Banner = ({ name, alt = 'Laura Candela' }) => {
  return (
    <div className="banner">
      <img
        className="imgBanner"
        src={name}
        alt={alt}
        loading="eager"
      />
    </div>
  );
};

export default Banner;